import { ApiTwoTone } from "@ant-design/icons";
import React from "react";
import { useSelector } from "react-redux";

export const OnlineIndicator = () => {
  const network_online = useSelector((state) => state.flights.network_online);

  if (network_online) return null;
  return (
    <div className="row" style={{ alignItems: "center", marginRight: 6 }}>
      <ApiTwoTone
        style={{ marginRight: 6 }}
        className="pulse"
        twoToneColor="white"
      />
      <span className="small" style={{ color: "white" }}>
        offline
      </span>
    </div>
  );
};
